import { FilePdfOutlined } from '@ant-design/icons'
import { INewTumRegister } from 'app/api/newTumRegister/model'
import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { convertColumnTable } from 'app/components/tables/BaseTableReport/hook'
import { useApproveManyTum } from 'app/react-query/hook/newTumRegister'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { ENewTumRegisterStatus } from '../../type'
import { handleDownloadFile } from 'app/service/general/service'

interface IProps {
  tums: INewTumRegister[]
}

export const ApproveManyTumModal = ({ tums }: IProps) => {
  const { t } = useTranslation()
  const modalRef = useRef<IRefModal>({})

  const { mutateAsync: mutateAsyncApprove, isLoading } = useApproveManyTum()

  const onSubmit = async () => {
    try {
      await mutateAsyncApprove(
        tums?.map(itm => ({
          id: parseInt(itm?.id ?? ''),
          status: ENewTumRegisterStatus.ACCEPTED,
        })),
      )
      modalRef.current?.hide?.()
    } catch (error) {
      console.log('Error:', error)
    }
  }

  const onClickDownloadFile = async (file?: string) => {
    if (file) {
      await handleDownloadFile({
        fileUrl: file,
      })
    }
  }

  return (
    <BaseModalComponent
      titleModal={'Phê duyệt nhiều đoàn viên'}
      titleOpenModal="Phê duyệt đoàn viên đã chọn"
      widthModal={900}
      ref={modalRef}
      handleSubmit={onSubmit}
      isLoadingConfirm={isLoading}
      isDisableSubmit={!tums?.length}
      styleButtonOpen={{
        border: `1px solid ${convertedVariables.neutralBlack2Color}`,
        borderRadius: 8,
      }}
      renderContent={
        <BaseSpace>
          <BaseRow gutter={8} align={'middle'} justify={'center'}>
            <BaseCol>
              <BaseText fontWeight="medium" fontSize="xs">
                {'Bạn có thực sự muốn phê duyệt các đoàn viên sau?'}
              </BaseText>
            </BaseCol>
          </BaseRow>
          <BaseTableManagement
            columns={[
              convertColumnTable<INewTumRegister>({
                key: 'fullName',
                title: t(R.strings.full_name),
                fixed: 'left',
                render: (_, record) => {
                  return (
                    <BaseText
                      fontWeight="semibold"
                      children={record?.fullName ?? '-'}
                    />
                  )
                },
              }),
              convertColumnTable<INewTumRegister>({
                key: 'mql',
                title: t(R.strings.id_management),
                render: (_, record) => {
                  return (
                    <BaseText
                      fontWeight="semibold"
                      children={record?.mql ?? '-'}
                    />
                  )
                },
              }),
              convertColumnTable<INewTumRegister>({
                key: 'email',
                title: t(R.strings.email),
                render: (_, record) => {
                  return (
                    <BaseText
                      fontWeight="medium"
                      opacity="0.7"
                      children={record?.email ?? '-'}
                    />
                  )
                },
              }),
              convertColumnTable<INewTumRegister>({
                key: 'tenDonVi',
                title: 'Đơn vị UEH',
                render: text => {
                  return (
                    <BaseText
                      fontWeight="medium"
                      opacity="0.7"
                      children={text}
                    />
                  )
                },
              }),

              convertColumnTable<INewTumRegister>({
                key: 'gioiTinh',
                title: t(R.strings.gender),
                render: (_, record) => {
                  return (
                    <BaseText
                      fontWeight="medium"
                      opacity="0.7"
                      children={record?.gioiTinh ?? '-'}
                    />
                  )
                },
              }),

              convertColumnTable<INewTumRegister>({
                key: 'activityEngagement',
                title: t(R.strings.status_union_activities),
                render: (_, record) => {
                  return (
                    <BaseText
                      fontWeight="medium"
                      opacity="0.7"
                      children={record?.activityEngagement?.name ?? '-'}
                    />
                  )
                },
              }),

              convertColumnTable<INewTumRegister>({
                key: 'school',
                title: 'Công đoàn bộ phận',
                render: (_, record) => {
                  return (
                    <BaseText
                      fontWeight="medium"
                      opacity="0.7"
                      children={record?.school?.name ?? '-'}
                    />
                  )
                },
              }),

              convertColumnTable<INewTumRegister>({
                key: 'created_by',
                title: 'Người tạo',
                render: (_, record) => {
                  return (
                    <BaseSpace size={4}>
                      <BaseText
                        fontWeight="semibold"
                        children={record?.created_by?.full_name ?? '-'}
                      />
                      <BaseText
                        fontWeight="medium"
                        opacity="0.7"
                        children={record?.created_by?.email ?? '-'}
                      />
                    </BaseSpace>
                  )
                },
              }),

              convertColumnTable<INewTumRegister>({
                key: 'dienThoaiDiDong',
                title: t(R.strings.phone),
                render: (_, record) => {
                  return (
                    <BaseText
                      fontWeight="medium"
                      opacity="0.7"
                      children={record?.dienThoaiDiDong ?? '-'}
                    />
                  )
                },
              }),

              convertColumnTable<INewTumRegister>({
                key: 'file',
                title: 'Đơn gia nhập',
                render: (_, record) => {
                  return (
                    <BaseRow
                      gutter={6}
                      align={'middle'}
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        onClickDownloadFile(record?.file)
                      }
                      justify={'start'}
                    >
                      <BaseCol>
                        <FilePdfOutlined rev={undefined} />
                      </BaseCol>
                      <BaseCol>
                        <BaseText
                          children={record?.file_name ?? 'Không có'}
                          colorText="collapseBackgroundColor"
                          fontWeight="medium"
                        />
                      </BaseCol>
                    </BaseRow>
                  )
                },
              }),
            ]}
            dataSource={tums}
            pagination={false}
            loading={isLoading}
            rowClassName="row-overwrite-style"
            scroll={{
              x: true
            }}
          />
        </BaseSpace>
      }
    />
  )
}
